import { getDateNYC } from '@insticator/insticator-ui';

export const lastScan = () => {
    const nycDate = getDateNYC();
    const time = nycDate.getHours();
    if(time < 19){
        return (time + 5)
    }
    return time - 19
};